/*eslint-disable*/
import React, { useState, useContext, useEffect } from "react";
import AppContext from "../../container/context";
import Table from "../../components/table/Table";
import api from "../../services/api";
import serverHost from "../../services/serverHost";

import { Button, Grid, TextField, Tooltip } from "@mui/material";
import { Close, KeyboardArrowRight } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles();

const Carrinho = ({ history }) => {
  const classes = useStyles();

  const [carrinho, setCarrinho] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    api
      .get("carrinhos/carregar")
      .then((dados) => {
        setCarrinho(dados);
        atualizarItensCarrinhoGlobal(carrinho.length);
      })
      .catch((e) => "Erro: " + e);
  };

  const fechar = () => {
    history.push("/app/carrinho/fechamento");
  };

  const atualizarCampoQuantidade = (quantidade, item) => {
    if (quantidade <= 0) return;

    const carrinhoAtualizado = [...carrinho];

    carrinhoAtualizado
      .filter((i) => i.produtoId === item.produtoId)
      .forEach((i) => (i.quantidade = quantidade));

    setCarrinho(carrinhoAtualizado);
  };

  const alterarQuantidade = (quantidade, item) => {
    if (Number(quantidade) === item.quantidade) return;

    const itemAlterar = {
      produtoId: item.produtoId,
      valor: item.valorItemCentavos,
      quantidade,
    };
    console.log(itemAlterar);
    api
      .post("carrinhos/editarItem", itemAlterar)
      .then((res) => {
        setCarrinho(res);

        return notification(
          "warning",
          `${item.produtoNome}: Quantidade alterada para ${quantidade}.`
        );
      })
      .catch((err) => {
        const { data } = err.response;
        switch (data[0]) {
          case 1:
            return notification("error", "Usuário inválido");
          case 2:
            return notification("error", "Quantidade inválida");
          case 3:
            return notification("error", "Valor inválido");
          case 4:
            return notification("error", "Produto inválido");
          case 5:
            return notification(
              "error",
              "Produto com venda exclusiva para outra(s) escola(s)"
            );

          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const removerItem = (item) => {
    item.removerTodos = true;

    api
      .post("carrinhos/removerItem", item)
      .then((res) => {
        setCarrinho(res);
        return notification("warning", `${item.produtoNome} removido.`);
      })
      .catch((e) => {
        return notification("error", "Não foi possível remover o item.");
      });
  };

  const registrosTabela = montarTabelaCarrinho(
    history,
    carrinho,
    fechar,
    atualizarCampoQuantidade,
    alterarQuantidade,
    removerItem
  );

  return (
    <div className="main-container">
      <Grid container>
        <Grid item md={12}>
          <Table
            tableHead={[
              "",
              "PRODUTO",
              "QUANTIDADE",
              "VALOR UNITÁRIO",
              "VALOR TOTAL",
              "",
            ]}
            tableData={registrosTabela}
            tableShopping
            customHeadCellClasses={[
              classes.textCenter,
              classes.description,
              classes.description,
              classes.textRight,
              classes.textRight,
              classes.textRight,
            ]}
            customHeadClassesForCells={[0, 2, 3, 4, 5, 6]}
            customCellClasses={[
              classes.tdName,
              classes.customFont,
              classes.customFont,
              classes.tdNumber,
              classes.tdNumber + " " + classes.tdNumberAndButtonGroup,
              classes.tdNumber + " " + classes.textCenter,
            ]}
            customClassesForCells={[1, 2, 3, 4, 5, 6]}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default Carrinho;

const montarTabelaCarrinho = (
  history,
  carrinho,
  fechar,
  atualizarCampoQuantidade,
  alterarQuantidade,
  removerItem
) => {
  const classes = useStyles();

  const registros = [];

  let valorUnitarioItem = 0;
  let valorTotalItem = 0;
  let valorTotalGeral = 0;

  carrinho.forEach((item) => {
    valorUnitarioItem = item.valorItemCentavos;
    valorTotalItem = valorUnitarioItem * item.quantidade;

    let promocaoItem;

    item.promocoes
      .filter((p) => p.valida)
      .forEach((p) => {
        valorUnitarioItem = p.valorCentavos;
        valorTotalItem = valorUnitarioItem * item.quantidade;

        return (promocaoItem = p);
      });

    valorTotalGeral += valorTotalItem;

    registros.push([
      <div className={classes.imgContainer} key={1}>
        <img
          style={{ width: "146px" }}
          src={`${serverHost()}/${item.produtoImagemPrincipal}`}
          alt={`Imagem do produto ${item.produtoNome}`}
          className={classes.img}
        />
      </div>,
      <span key={1}>
        {/* <a
          style={{ fontWeight: "bold", fontSize: "20px" }}
          href={`produto/${item.produtoId}`}
        >
          {item.produtoNome}
        </a> */}
        <h4
          style={{ fontWeight: "bold", fontSize: "20px", color: "#9C27B0" }}
          onClick={() =>
            history.push(`/app/catalogo/produto/${item.produtoId}`)
          }
        >
          {item.produtoNome}
        </h4>
        <br />
        <small style={{ fontSize: "15px" }}>{item.produtoDescricao}</small>
        {promocaoItem && (
          <div style={{ background: "#afcca9", padding: 5 }}>
            <h4>Promoção/Condição especial de venda</h4>
            <small>{promocaoItem.descricao}</small>
          </div>
        )}
      </span>,
      <TextField
        className="main-input"
        fullWidth
        id="standard-search"
        type="number"
        value={item.quantidade}
        onChange={(e) => atualizarCampoQuantidade(e.target.value, item)}
        onBlur={(e) => alterarQuantidade(e.target.value, item)}
      />,
      <div>{`R$ ${(valorUnitarioItem / 100).toFixed(2)}`}</div>,
      <div>{`R$ ${(valorTotalItem / 100).toFixed(2)}`}</div>,
      <Tooltip
        key={1}
        id="close1"
        title="Remove item"
        placement="left"
        classes={{ tooltip: classes.tooltip }}
      >
        <Button
          color="primary"
          variant="contained"
          link
          className={classes.actionButton}
          onClick={() => removerItem(item)}
        >
          <Close />
        </Button>
      </Tooltip>,
    ]);
  });

  registros.push({
    purchase: true,
    colspan: "3",
    amount: (
      <span>
        <div>R$ {(valorTotalGeral / 100).toFixed(2)}</div>
      </span>
    ),
    col: {
      colspan: 3,
      text: (
        <Button variant="contained" color="primary" onClick={fechar} round>
          Finalizar <KeyboardArrowRight />
        </Button>
      ),
    },
  });

  return registros;
};

const atualizarItensCarrinhoGlobal = (qtd) => {
  localStorage.setItem("painel-escolas@itens-carrinho", qtd);
};
